function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { cloneElement, PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./preview-base-segment-component.scss";
import PencilIcon from "static/svg/pencil.svg";
import BinIcon from "static/svg/bin.svg";
import CopyIcon from "static/svg/copy2.svg";
import PasteIcon from "static/svg/paste2.svg"; //to replace
import { SortableElement, sortableHandle } from "react-sortable-hoc";
import DragHandleIcon from "/static/svg/icons/drag-handle.svg";
import ReactTooltip from "react-tooltip";
import EarthIcon from "static/svg/earth.svg";
import { isFooterComponent } from "components/templates/dynamic-template/dynamic-template-service";
import { COUNTRY_DISPLAY_MODE } from "segments/desktop/shared-advanced-fields-config";
const DragHandle = sortableHandle(()=>/*#__PURE__*/ _jsx(DragHandleIcon, {}));
const tooltipDelay = 250;
class PreviewBaseSegmentComponent extends PureComponent {
    shouldShowLocationIcon() {
        const { children } = this.props;
        const { countrySpecificDisplaySettings } = children.props.segment.props;
        return (countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.countryDisplayMode) && (countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.country);
    }
    getLocationIconDataTip() {
        const { children } = this.props;
        const { countrySpecificDisplaySettings } = children.props.segment.props;
        if (!countrySpecificDisplaySettings) return "";
        const { countryDisplayMode, country } = countrySpecificDisplaySettings;
        return `${countryDisplayMode === COUNTRY_DISPLAY_MODE.INCLUDE ? "Show" : "Hidden"} only on ${country}`;
    }
    render() {
        const { selectedSegmentIndex, index } = this.props;
        const { hasCopied } = this.state;
        const isSelected = selectedSegmentIndex === index;
        const style = this.getPreviewBaseLayoutStyle();
        return /*#__PURE__*/ _jsxs("div", {
            style: style,
            onClick: this.editComponent,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("preview-base-segment-component", {
                "is-selected": isSelected
            }) || ""),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "preview-overlay",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            "data-for": `tooltip_drag_${index}`,
                            "data-tip": "Reorder",
                            className: `jsx-${componentStyles.__hash}` + " " + "drag-icon-wrapper icon-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: `tooltip_drag_${index}`,
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ _jsx(DragHandle, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            "data-for": `tooltip_edit_${index}`,
                            "data-tip": "Edit",
                            onClick: this.editComponent,
                            className: `jsx-${componentStyles.__hash}` + " " + "edit-icon-wrapper icon-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: `tooltip_edit_${index}`,
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ _jsx(PencilIcon, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            "data-for": `tooltip_remove_${index}`,
                            "data-tip": "Remove",
                            onClick: this.removeSegment,
                            className: `jsx-${componentStyles.__hash}` + " " + "remove-icon-wrapper icon-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: `tooltip_remove_${index}`,
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ _jsx(BinIcon, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            "data-for": `tooltip_copy_${index}`,
                            "data-tip": "Copy component",
                            onClick: this.copySegmant,
                            className: `jsx-${componentStyles.__hash}` + " " + "copy-icon-wrapper icon-wrapper",
                            children: [
                                !hasCopied && /*#__PURE__*/ _jsx(ReactTooltip, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: `tooltip_copy_${index}`,
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ _jsx(CopyIcon, {}),
                                hasCopied && /*#__PURE__*/ _jsx("span", {
                                    className: `jsx-${componentStyles.__hash}` + " " + "has-copied",
                                    children: "Copied!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            onClick: this.pasteSegment,
                            "data-for": `tooltip_paste_${index}`,
                            "data-tip": "Paste component below",
                            className: `jsx-${componentStyles.__hash}` + " " + (classnames("paste-icon-wrapper", "icon-wrapper", {
                                disabled: this.isPasteSegmentDisabled()
                            }) || ""),
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: `tooltip_paste_${index}`,
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ _jsx(PasteIcon, {})
                            ]
                        })
                    ]
                }),
                this.shouldShowLocationIcon() && /*#__PURE__*/ _jsxs("div", {
                    "data-for": `tooltip_location_${index}`,
                    "data-tip": this.getLocationIconDataTip(),
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("location-icon-wrapper", "icon-wrapper", {
                        disabled: this.isPasteSegmentDisabled()
                    }) || ""),
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            multiline: false,
                            className: "icon-wrapper-tooltip",
                            id: `tooltip_location_${index}`,
                            effect: "solid",
                            place: "bottom",
                            delayShow: tooltipDelay
                        }),
                        /*#__PURE__*/ _jsx(EarthIcon, {})
                    ]
                }),
                this.childrenRendererWithoutBaseLayoutStyles(),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "editComponent", (e)=>{
            const { index, setSelectedSegmentIndex } = this.props;
            setSelectedSegmentIndex(index);
            e.stopPropagation();
        });
        _define_property(this, "removeSegment", (e)=>{
            const { index, onRemoveSegment } = this.props;
            onRemoveSegment(index);
            e.stopPropagation();
        });
        _define_property(this, "copySegmant", (e)=>{
            const { setCopiedSegment, segment } = this.props;
            setCopiedSegment(segment);
            e.stopPropagation();
            this.setState({
                hasCopied: true
            });
            setTimeout(()=>{
                this.setState({
                    hasCopied: false
                });
            }, 2000);
        });
        _define_property(this, "pasteSegment", (e)=>{
            // if not allowed to paste, do nothing
            if (this.isPasteSegmentDisabled()) return;
            const { copiedSegment, onPasteSegment, index } = this.props;
            if (!copiedSegment) return;
            onPasteSegment(index, copiedSegment);
            e.stopPropagation();
        });
        _define_property(this, "getPreviewBaseLayoutStyle", ()=>{
            const { segment } = this.props;
            return segment.props && segment.props.baseLayoutStyleProps;
        });
        _define_property(this, "childrenRendererWithoutBaseLayoutStyles", ()=>{
            const { children } = this.props;
            if (!(children && children.props && children.props.segment && children.props.segment.props)) {
                return children;
            }
            //remove baseLayoutStyleProps from baseLayout - because we add these styles to the preview in getPreviewBaseLayoutStyle()
            const newProps = _object_spread_props(_object_spread({}, children.props), {
                segment: _object_spread_props(_object_spread({}, children.props.segment), {
                    props: _object_spread_props(_object_spread({}, children.props.segment.props), {
                        baseLayoutStyleProps: null
                    })
                })
            });
            return /*#__PURE__*/ cloneElement(children, newProps);
        });
        _define_property(this, "isPasteSegmentDisabled", ()=>{
            const { copiedSegment, segment } = this.props;
            return !copiedSegment || isFooterComponent(segment === null || segment === void 0 ? void 0 : segment.type);
        });
        this.state = {
            hasCopied: false
        };
    }
}
export default SortableElement((props)=>/*#__PURE__*/ _jsx(PreviewBaseSegmentComponent, _object_spread({}, props)));
